// extracted by mini-css-extract-plugin
export default {"root":"Checkbox_root__a5tAt","checked":"Checkbox_checked__WhOzV","unCheckedBorder":"Checkbox_unCheckedBorder__aetka","icon":"Checkbox_icon__twO-q","input":"Checkbox_input__eVCgi"};